import { render, staticRenderFns } from "./Facility.vue?vue&type=template&id=5b2ceda1&scoped=true"
import script from "./Facility.vue?vue&type=script&lang=js"
export * from "./Facility.vue?vue&type=script&lang=js"
import style0 from "./Facility.vue?vue&type=style&index=0&id=5b2ceda1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2ceda1",
  null
  
)

export default component.exports